import { rfqQuoteDetailsQuotedPricingStyles } from "@insite/content-library/Widgets/RfqQuoteDetails/RfqQuoteDetailsQuotedPricing";
import { css } from "styled-components";

rfqQuoteDetailsQuotedPricingStyles.quantityCell = {
    css: css`
            border: none;
            height: 30px;
            vertical-align: center;
        `,
};